export const RESET_CLIENT_INFO = "RESET_CLIENTCONVERSATIONS";
export const CLIENT_INFO_ERROR = "CLIENT_INFO_ERROR";
export const GET_CLIENT_INFO = "GET_CLIENT_INFO";
export const SET_CLIENT_INFO = "SET_CLIENT_INFO";
export const SET_CURRENT_CHAT_DATA = "SET_CURRENT_CHAT_DATA";
